import { defineComponent, h } from 'vue';
import { RouterView } from 'vue-router';

export default defineComponent({
  name: 'RouterViewComponent',
  render: () => h(RouterView),
});
